<div class="widget-container">
  <app-risk-gauge [riskAnalysis]="riskAnalysis"></app-risk-gauge>
</div>
